import { isEmpty, compose, not, propOr } from 'ramda';

const news = propOr([], 'news');

const isNewsNotEmpty = compose(not, isEmpty, news);

export { news, isNewsNotEmpty };
